var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wb-header"},[_c('div',{staticClass:"wb-header-content"},[_c('div',{staticClass:"logo"},[_c('wb-header-logo')],1),_c('div',{staticClass:"content"},[_c('wb-nav',{on:{"toggleMenu":_vm.toggleMenu}})],1),_c('wb-lang')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }